import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthGuardService } from './_services/auth-guard.service';
import { LoginRedirectGuardService } from './_services/login-redirect-guard.service';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { NamesSoundsComponent } from './school-management/names-sounds/names-sounds.component';
import { LayoutComponent } from './components/layout/layout.component';
import { BrowserUtils } from '@azure/msal-browser';
import { PREVIEW_ROUTES } from './game-preview/preview-routes';


const routes: Routes = [
    {
        path: 'login',
        canActivate: [LoginRedirectGuardService],
        component: LoginComponent
    },
    {
        path: 'login/:token',
        component: LoginComponent
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent
    },
    {
        path: 'dashboard',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule)
    },
    {
        path: 'messages',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./messages/messages.module').then(mod => mod.MessagesModule)
    },
    {
        path: 'messages-new',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./messages-new/messages-new.module').then(mod => mod.MessagesNewModule)
    },
    {
        path: 'buses',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./buses/buses.module').then(mod => mod.BusesModule)
    },
    // {
    //     path: 'reports',
    //     canActivate: [AuthGuardService],
    //     loadChildren: () => import('./reports/reports.module').then(mod => mod.ReportsModule)
    // },
    {
        path: 'reports-new',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./new-reports/new-reports.module').then(mod => mod.NewReportsModule)
    },
    {
        path: 'school-management',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./school-management/school-management.module').then(mod => mod.SchoolManagementModule)
    },
    {
        path: 'calling-screen',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./calling-screen/calling-screen.module').then(mod => mod.CallingScreenModule)
    },
    {
        path: 'bus-calling-screen',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./bus-calling-screen/bus-calling-screen.module').then(mod => mod.BusCallingScreenModule)
    },
    {
        path: 'gate-screen',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./gate-screen/gate-screen.module').then(mod => mod.GateScreenModule)
    },
    {
        path: 'gate-scanner',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./gate-scanner/gate-scanner.module').then(mod => mod.GateScannerModule)
    },
    {
        path: 'cafeteria-scanner',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./cafeteria-scanner/cafeteria-scanner.module').then(mod => mod.CafeteriaScannerModule)
    },
    {
        path: 'grade-management',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./grade-management/grade-management.module').then(mod => mod.GradeManagementModule)
    },
    {
        path: 'delegation',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./delegation/delegation.module').then(mod => mod.DelegationModule)
    },
    {
        path: 'attendance',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./attendance/attendance.module').then(mod => mod.AttendanceModule)
    },
    {
        // the side bar links here (/names-sounds/); same layout the page had before
        path: 'names-sounds',
        canActivate: [AuthGuardService],
        component: LayoutComponent,
        children: [
            { path: '', component: NamesSoundsComponent }
        ]
    },
    {
        path: 'data-management',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./data-management/data-management.module').then(mod => mod.DataManagementModule)
    },
    {
        path: 'appointments',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./appointments/appointments.module').then(mod => mod.AppointmentsModule)
    },
    // DEV-ONLY: isolated game preview harness (no auth). PREVIEW_ROUTES is
    // empty in production (angular.json fileReplacements swaps the source
    // file), so the harness + its lazy chunk never ship.
    ...PREVIEW_ROUTES,
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: '**', redirectTo: 'login'
    }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, {
        // Don't perform initial navigation in iframes or popups
        initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
    })],
    exports: [RouterModule],
})
export class AppRoutingModule { }